import { useState } from 'react';
import { api } from '../lib/api';
import { useAction, useApi } from '../lib/useApi';
import { ErrorBox, Loading, Notice, PageHeader, StatusBadge, fmtDate, money } from '../components/ui';

interface Trip {
  id: string;
  title: string;
  country: string;
  cities: string[];
  starts_on: string;
  ends_on: string;
  price_cents: number;
  currency: string;
  min_child_age: number;
  description: string;
  vendors: Array<{ name: string; type: string; vetted: boolean }>;
}

export function TripsPage() {
  const trips = useApi<{ trips: Trip[] }>('/trips');
  const bookings = useApi<{ bookings: Array<{ id: string; title: string; status: string; adults: number; children: number; starts_on: string }> }>('/trips/bookings');
  const act = useAction();
  const [party, setParty] = useState<Record<string, { adults: number; children: number }>>({});
  return (
    <>
      <PageHeader title="Heritage Trips" termKey="page.trips" lead="Small-group family journeys to the places your stories come from. Children always travel with their own adults; every vendor is vetted." />
      <Notice text={act.notice} />
      <ErrorBox error={act.error ?? trips.error} />
      {bookings.data && bookings.data.bookings.length > 0 && (
        <div className="card">
          <h2>Your enquiries</h2>
          <ul>
            {bookings.data.bookings.map((b) => (
              <li key={b.id}>
                <span className="yo">{b.title}</span> · {b.adults} adults, {b.children} children · <StatusBadge status={b.status} />
              </li>
            ))}
          </ul>
        </div>
      )}
      {trips.loading && <Loading />}
      <div className="grid grid-2" style={{ marginTop: 16 }}>
        {trips.data?.trips.map((t) => {
          const p = party[t.id] ?? { adults: 2, children: 1 };
          return (
            <article key={t.id} className="card stack">
              <h2 className="yo">{t.title}</h2>
              <p className="small muted">
                {fmtDate(t.starts_on, false)} – {fmtDate(t.ends_on, false)} · <span className="yo">{t.cities.join(', ')}</span> · from {money(t.price_cents, t.currency)} per person
              </p>
              <p>{t.description}</p>
              <p className="small">
                Vetted partners: {t.vendors.map((v) => `${v.name} (${v.type})`).join(', ') || '—'}
              </p>
              <form
                className="row"
                onSubmit={async (e) => {
                  e.preventDefault();
                  await act.run(() => api(`/trips/${t.id}/enquire`, { body: p }), 'Enquiry sent — our trips team will be in touch.');
                  bookings.reload();
                }}
              >
                <label className="small" htmlFor={`a-${t.id}`}>Adults</label>
                <input id={`a-${t.id}`} type="number" min={1} max={10} value={p.adults} style={{ width: 70 }} onChange={(e) => setParty({ ...party, [t.id]: { ...p, adults: Number(e.target.value) } })} />
                <label className="small" htmlFor={`c-${t.id}`}>Children</label>
                <input id={`c-${t.id}`} type="number" min={0} max={10} value={p.children} style={{ width: 70 }} onChange={(e) => setParty({ ...party, [t.id]: { ...p, children: Number(e.target.value) } })} />
                <button className="btn small">Enquire</button>
              </form>
            </article>
          );
        })}
      </div>
    </>
  );
}
